<template>
  <FocusLayout>
    <add-entity-form></add-entity-form>
  </FocusLayout>
</template>

<script>
import FocusLayout from "@/landing/layout/FocusLayout";

export default {
  components: {
    FocusLayout,
  },
};
</script>

<style></style>
